import { Document, Session } from "@/tools/msa/models";
import { Page } from "@/tools/msa/models/requests/extraction/legacy";
import { analyzeDocument } from "@/tools/msa/processing/analysis";
import { tokeniseDocument } from "@/tools/msa/processing/tokenisation";

export const makePartialDocument = async (
  pages: Page[],
  session: Session
): Promise<Document> =>
  await Promise.resolve({
    tokens: [],
    items: [],
    date: null,
    providerName: "",
    practice: "",
    chiefComplaint: "",
    diagnoses: "",
    assessments: "",
    medications: "",
    plans: "",
    dateOfBirth: null,
    pages: pages.map(page => ({
      text: page.text,
      number: page.number,
      sections: [],
      tokens: [],
      date: null
    }))
  })
    .then(document => tokeniseDocument(document, session))
    .then(document => analyzeDocument(document, session));
